// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HMaKQ","label":"styles_label__1AQii"};